<template>
  <div>
    <Campaigns
      v-if="showComponent"
      mobile
    />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import useJwt from '@/auth/jwt/useJwt'
import { locales } from '@/libs/i18n/all-locales'
import { localeChanged, localize } from 'vee-validate'
import Campaigns from './components/Index.vue'

export default {
  name: 'CampaignsMobile',
  components: {
    Campaigns,
  },
  data() {
    return {
      showComponent: false,
    }
  },
  created() {
    // Önceki key'leri temizle
    useJwt.setToken(null)
    useJwt.setApiKey(null)

    const token = this.$cookies.get('token')
    const apiKey = this.$cookies.get('api-key')
    const locale = this.$cookies.get('locale')

    // Cookie'den dil geldiyse o dili ayarla
    if (locale) {
      const selectedLocale = locales.find(l => l.locale === locale)

      if (selectedLocale) {
        this.updateLocale(locale)
      }
    }

    if (token && apiKey) {
      useJwt.setToken(token)
      useJwt.setApiKey(apiKey)

      // Kişinin bilgilerini getir ve güncelle
      useJwt.getMe()
        .then(response => {
          this.$store.dispatch('auth/updateUser', response.data.body)
        })

      setTimeout(() => {
        this.showComponent = true
      }, 33)

      if (window.webkit) {
        if (window.webkit.messageHandlers && window.webkit.messageHandlers.iosListener) {
          // eslint-disable-next-line radix
          window.webkit.messageHandlers.iosListener.postMessage({ key: 'update-title', title: this.$t('Campaigns') })
        }
      }
      if (window.AndroidApp) {
        // eslint-disable-next-line radix
        window.AndroidApp.sendData(JSON.stringify({ key: 'update-title', title: this.$t('Campaigns') }))
      }
    }
  },
  methods: {
    updateLocale(locale) {
      this.$i18n.locale = locale
      localize(locale)
      localeChanged()
      localStorage.setItem('locale', locale)

      if (locale === 'ar') {
        localStorage.setItem('isRTL', 'on')
      }
      this.$store.commit('appConfig/TOGGLE_RTL', locale === 'ar')

      this.updateLocaleFromServer(locale)
    },
    updateLocaleFromServer(lang) {
      if (lang) {
        useJwt.updateLanguage(lang)
      }
    },
  },
}
</script>
